import TextField from "../../../components/fields/textField/TextField.vue";
import SelectField from "../../../components/fields/selectField/SelectField.vue";
import AutocompleteField from "../../../components/fields/autocompleteField/AutocompleteField.vue";
import PeriodoField from "../../../components/fields/periodoField/PeriodoField.vue";

import ReprogramarPeriodo from "../calendario-ferias/reprogramar-ferias/ReprogramaFerias.vue"

import AjustarFerias from "./../calendario-ferias/ajustar-ferias/AjustarFerias.vue";

import AnalisarReprogramacao from "./../calendario-ferias/analisar-reprogramacao/AnalisarReprogramacao.vue";

import AnalisarFerias from "./../calendario-ferias/analisar-ferias-civil/AnalisarFerias.vue";
import SolicitarFeriasCivil from "./../calendario-ferias/solicitar-ferias-civil/SolicitarFeriasCivil.vue";
import FeriasVantagem from "../../calendario-ferias/ferias-vantagem/FeriasVantagem.vue";
import FeriasProrrogada from "../../calendario-ferias/ferias-prorrogadas/FeriasProrrogadas.vue";

import SolicitarFeriasPremio from "./../calendario-ferias/ferias-premio/FeriasPremio.vue";

import AprovarFeriasLote from "./../calendario-ferias/aprovar-ferias-lote-civil/AprovarFeriasLote.vue";

import ConvocarFerias from "./../calendario-ferias/convocar-ferias/ConvocarFerias.vue";
import AnalisarConvocacao from "./../calendario-ferias/analisar-convocacao/AnalisarConvocacao.vue";

import AgendarFerias from "./../calendario-ferias/agendar-ferias-civil/AgendarFerias.vue";
import ConfirmDialog from "../../../components/dialog/confirm/ConfirmDialog.vue";
import OkayDialog from "../../../components/dialog/okay/OkayDialog.vue"
import MilitaresFeriasAVencer from "../../calendario-ferias/menssagem/militares-ferias-a-vencer/MilitaresFeriasAVencer.vue"
import MilitaresNaoAgendado from "../../calendario-ferias/menssagem/militares-nao-agendados/MilitaresNaoAgendado.vue"

import { FeriasCivilService } from "../../../services/FeriasCivilService";
import { FeriasService } from "../../../services/FeriasService";
import { MensagensService } from "../../../services/MensagensService";

import moment from "moment";
import { FUNCIONALIDADES, ServidorCivil, tipoPerfil } from "../../../constants";
import { date } from "date-typescript-library";
import PerfilService from "@/services/PerfilService";
import { numeroBmMixin } from "../../../mixins/numeroBmMixin";
import { ExcluirFeriasService } from "../../../services/ExcluirFeriasService";


export default {
  name: "CalendarioFerias",

  components: {
    TextField,
    SelectField,
    AutocompleteField,
    PeriodoField,
    ReprogramarPeriodo,
    AjustarFerias,
    AnalisarReprogramacao,
    AnalisarFerias,
    SolicitarFeriasCivil,
    FeriasVantagem,
    FeriasProrrogada,
    SolicitarFeriasPremio,
    AnalisarConvocacao,
    ConvocarFerias,
    AgendarFerias,
    AprovarFeriasLote,
    ConfirmDialog,
    OkayDialog,
    MilitaresFeriasAVencer,
    MilitaresNaoAgendado,
  },

  mixins:[numeroBmMixin],

  data: () => ({
    headers: [
      { text: "Nº BM", value: "numero", width: "7%" },
      // { text: "Posto/Graduação", value: "graduacao", width: "150px" },
      { text: "Nome Civil", value: "nome", width: "120px" },
      { text: "Unidade/Lotação", value: "unidade", width: "150px" },
      { text: "Exercício", value: "exercicio", width: "110px" },
      { text: "Período de Férias", value: "periodo" },
      { text: "Dias de Férias", value: "diasFerias", width: "110px" },
      { text: "Dias Restantes", value: "diasRestantes", width: "110px" },
      { text: "Parcela", value: "parcela", width: "110px" },
      { text: "Abono", value: "status_abono", width: "110px" },
      { text: "Tipo Ferias", value: "tipo", width: "110px" },
      { text: "Status", value: "status", width: "110px" },
      { text: "Ações", value: "actions", sortable: false, align: "center" },
      {
        text: "Excluir Férias",
        value: "exclui",
        sortable: false,
        align: "center",
      },

    ],
    perfil:[],
    items: [],
    page: 1,
    totalItems: 0,

    permissaoSolicitarFerias: false,

    selected: [],
    selectedAction: {},
    singleSelect: false,
    idSelected: null,
    statusSelected: "",
    periodoSelected: "",
    numeroDiasSelected: "",
    menssagens:[],

    unidade: [],
    filter: {},

    optionsFilter: {
      postoGraduacao: [],
      status: [],
      unidadeLotacao: [],
      exercicio: [],
      exercicioPesquisar:[],
      perfil:[],
      tipo_civil: ServidorCivil
    },

    actionsDialog: false,
    ReprogramarPeriodoDialog: false,
    ajustarFeriasDialog: false,
    analisarReprogramacaoDialog: false,
    analisarFeriasDialog: false,
    solicitarFeriasDialog: false,
    FeriasVantagemDialog: false,
    FeriasProrrogadaDialog: false,
    solicitarFeriasPremioDialog: false,
    solicitarFerias30AnosDialog: false,
    AnalisarConvocacaoDialog: false,
    convocarFeriasDialog: false,
    AgendarFeriasDialog: false,
    aprovarFeriasLoteDialog: false,
    confirmDialog: false,
    OkayDialog: false,
    MilitaresFeriasAVencerDialog:false,
    MilitaresNaoAgendadoDialog:false,
    disabledLotacao: true,
    loading: {
      table: false,
      btn: false,
      field: false,
    },
  }),

  beforeMount() {
    this.initializeFilter();
    },

  async mounted() {
    this.getPermissaoSolicitarFerias();
    this.getMenssagens();
    this.setPerfilList();
    await this.getFerias();
    this.getGraduacaoItems();
    this.getUnidadeItems();
    this.getExercicioItems();
    this.getExercicioPesquisar();
    this.getStatusItems();
    this.getPerfilItems();
    //this.MilitaresFeriasAVencerDialog = this.$store.state.user.Perfis.indexOf(tipoPerfil['CHEFE_SEPLAN']) != -1;
    //this.MilitaresNaoAgendadoDialog = this.$store.state.user.Perfis.indexOf(tipoPerfil['CHEFE_SEPLAN']) != -1;
  },

  computed: {
    mapItems() {
      return this.items.map((x) => ({
        ...x,
        isSelectable: x.status.slice(0, 10) == "Em Análise",
      }));
    },
    funcionalidadesEnum() {
      return FUNCIONALIDADES;
    },
    solicitante() {
      const userPerfis = this.$store.state.user.Perfis;
      const solicitanteIndex = userPerfis.indexOf(tipoPerfil['SOLICITANTE']);
      
      return solicitanteIndex !== -1 && userPerfis.length > 1;
    },
    chefeSeplan () {
      return this.verificarSePerfilTemPermissao('CHEFE_SEPLAN');
    },
    pageCount() {
      if (this.items) {
        return Math.ceil(this.totalItems / 10);
      }
      return 0;
    }
  },

  filters: {
    formatPeriodo(string) {
      if (typeof string == "string") {
        const splitDate = string.split(" à ");
        return `${moment(splitDate[0]).format("DD/MM/YYYY")} à ${moment(
          splitDate[1]
        ).format("DD/MM/YYYY")}`;
      }
      return string;
    },
  },

  watch: {
    page: async function(val) {
      this.page = val;
      await this.getFerias();
    },
    'unidade': function(unidade) {
      if (unidade) {
        this.getLotacoesItems(unidade);
        this.disabledLotacao = false;
      } else {
        this.disabledLotacao = true;
        this.unidade = null;
        this.filter.lotacao = null;
      }
    }
  },

  methods: {
    initializeFilter() {
      this.filter = {
        dataInicio: null,
        dataFim: null,
        tipo_civil: null,
      };
    },
    async getLotacoesItems(unidade) {
      this.loading.field = true;
      const response = await FeriasCivilService.getLotacaoByUnidade(unidade);
      this.optionsFilter.lotacao = response.map((el) => {
        return {
          text: el.nome,
          value: el.id,
        };
      });
      this.loading.field = false;
    },
    async getMenssagens(){
      const response = await MensagensService.getMensagens();
      if(response){
        this.menssagens = response;
        this.OkayDialog = true;
      }

    },

    async getFerias() {
      this.loading.table = true;
      const filter = this.prepareFormFilter();
      const response = await FeriasService.obterFerias(filter);

      this.items = response.data;
      this.totalItems = response.total;
      this.loading.table = false;
      this.$forceUpdate();
    },

    prepareFormFilter() {
      const filter = new FormData();

      filter.append("civil", 1);
      filter.append("page", this.page);
      this.filter.tipo_civil
      ? filter.append("tipo_civil", this.filter.tipo_civil)
      : null;


      if (this.filter.numeroBM) {
        const numeroBM = this.filter.numeroBM.replace(".", "");
        const [numero, digitoVerificador] = numeroBM.split("-");
        filter.append("numero", this.removerZero(numero));
        if (digitoVerificador != undefined) filter.append("digito_verificador", digitoVerificador);
      }

      this.filter.nomeUsuario
        ? filter.append("nome", this.filter.nomeUsuario)
        : null;
      this.filter.postoGraduacao
        ? filter.append("id_graduacao", this.filter.postoGraduacao)
        : null;
        if (Array.isArray(this.filter.status) && this.filter.status.length > 0) {
          const validStatus = this.filter.status.filter(s => s !== null && s !== '');
          if (validStatus.length > 0) {
            filter.append("status", validStatus.join(','));
          }
        }

      this.filter.dataInicio
        ? filter.append(
            "data_ini",
            moment(this.filter.dataInicio).format("YYYY-MM-DD")
          )
        : null;
      this.filter.dataFim
        ? filter.append(
            "data_fin",
            moment(this.filter.dataFim).format("YYYY-MM-DD")
          )
        : null;
      this.unidade
        ? filter.append("id_unidade", this.unidade)
        : null;
        this.filter.lotacao
        ? filter.append("id_lotacao", this.filter.lotacao)
        : null;  
      this.filter.exercicio
        ? filter.append("exercicio", this.filter.exercicio)
        : null;
      this.filter.perfil
        ? filter.append('id_perfil',this.filter.perfil)
        : null;
      return filter;
    },

    async getGraduacaoItems() {
      this.loading.field = true;
      const response = await FeriasCivilService.getGraduacao();
      this.optionsFilter.postoGraduacao = response.map((el) => {
        return {
          text: el.descricao,
          value: el.id,
        };
      });
      this.optionsFilter.postoGraduacao?.unshift({
        text: "Selecione",
        value: "",
      });
      this.loading.field = false;
    },

   async getUnidadeItems() {
      this.loading.field = true;
      const response = await FeriasCivilService.getUnidade();
      this.optionsFilter.unidadeLotacao = response.map((el) => {
        return {
          text: el.nome_abreviado,
          value: el.id,
        };
      });
      this.optionsFilter.unidadeLotacao?.unshift({
        text: "Selecione",
        value: "",
      });
      this.loading.field = false;
    }, 

    async getExercicioItems() {
      this.loading.field = true;
      const response = await FeriasCivilService.getExercicio();
      this.optionsFilter.exercicio = response.map((el) => {
        return {
          text: el.ano,
          value: el.ano,
        };
      });
      this.optionsFilter.exercicio?.unshift({ text: "Selecione", value: "" });
      this.loading.field = false;
    },
    async getExercicioPesquisar() {
      this.loading.field = true;
      const response = await FeriasCivilService.getExerciciosPesquisar();
      this.optionsFilter.exercicioPesquisar = response.map((el) => {
        return {
          text: el.ano,
          value: el.ano,
        };
      });
      this.optionsFilter.exercicioPesquisar?.unshift({ text: "Selecione", value: "" });
      this.loading.field = false;
    },

    async getStatusItems() {
      this.loading.field = true;
      const response = await FeriasCivilService.getStatus();
      this.optionsFilter.status = response.map((el) => {
        return {
          text: el.tipo_status,
          value: el.id,
        };
      });
      // this.optionsFilter.status?.unshift({ text: "Selecione", value: "" });
      this.loading.field = false;
    },

    async getPermissaoSolicitarFerias(){
      this.permissaoSolicitarFerias  = await FeriasCivilService.getValidacaoSolicitacao();
    },

    async setPerfilList() {
      this.perfil = tipoPerfil;
    },
    async getPerfilItems() {
      this.loading.field = true;
      const response = await PerfilService.getPerfis();
      this.optionsFilter.perfil = response.map((el) => {
        return {
          text: el.nome,
          value: el.id,
        };
      });
      this.optionsFilter.perfil?.unshift({ text: "Selecione", value: "" });
      this.loading.field = false;
    },


    openActionsDialog(item) {
      this.actionsDialog = true;
      this.idSelected = item.idFerias;
      this.periodoSelected = item.periodo;
      this.numeroDiasSelected = item.diasFerias;
      this.statusSelected = item.status;
      this.selectedAction = {
        idTipo: item.idTipo ? item.idTipo : "",
        idPerfil: item.id_perfil? item.id_perfil: "",
        idSigrh: item.idSigrh? item.idSigrh : "",
        idFerias: item.idFerias? item.idFerias : "",
        idUnidade: item.idUnidade? item.idUnidade : "",
        nBM: item.numero ? item.numero : "",
        posto: item.graduacao ? item.graduacao : "",
        nome: item.nome ? item.nome : "",
        periodoAlterado: item.periodoAlterado ? item.periodoAlterado : "",
        numeroDias: item.diasFerias ? item.diasFerias : "",
        dataIni: item.dataIni ? item.dataIni : "",
        dataFin: item.dataFin ? item.dataFin : "",
        IdStatus: item.IdStatus? item.IdStatus: "",

      };

    },

    openDeleteDialog(item) {
      this.idSelected = item.idFerias;
      this.confirmDialog = true;

    },

    async lerMenssagem(id, index){
      const response = MensagensService.lerMenssagem(id)
      if(response){
        this.menssagens.splice(index, 1);
      }
      if(this.menssagens.length == 1){
        this.OkayDialog = false;
      }
    },

    async verificarMilitaresSemAgendamentoFerias() {
      const response = MensagensService.verificarMensagemChefeSeplanMilitaresSemAgendamento()
      this.MilitaresNaoAgendadoDialog = response.data;
    },

    verificarAprovarLote(status){
      const verificarChefeDireto = (this.$store.state.user.Perfis.indexOf(tipoPerfil['CHEFE_DIRETO']) != -1 && status == 'Em Análise do Chefe Direto')
      const verificarGerente = (this.$store.state.user.Perfis.indexOf(tipoPerfil['GERENCIA']) != -1 && status == 'Em Análise do Gerente (Chefe DRH)')
      const verificarChefeSeplan = (this.$store.state.user.Perfis.indexOf(tipoPerfil['CHEFE_SEPLAN']) != -1 && status == 'Em Análise do Chefe SEPLAN (Ou Similares)');
      if(this.selectedAction.IdStatus == 29){
        if(this.$store.state.user.Perfis.indexOf(tipoPerfil['GERENCIA']) != -1 ){
          return false;
        }
      }
      
      if(verificarChefeDireto){
        return false;
      }
  
      if(verificarGerente){
        return false;
      }
      if(verificarChefeSeplan){
        return false;
      }
      return true;
    },

    trocarHistoricoFerias(){
      this.$router.push({ name: 'HistoricoFerias', params:{ferias: this.selectedAction} })
    },

    verificarPermisao(){
      return (
        this.$store.state.user.Perfis.includes(tipoPerfil['SOLICITANTE']) &&
        this.$store.state.user.Perfis.length === 1
      );
    },

    verificarPermissaoAjustarFerias(){
      return this.$store.state.user.idSigrh == this.selectedAction.idSigrh;
    },

    verificarExcluirFerias(parametrizarExclusao){
      const verificarChefeSeplan = this.verificarSePerfilTemPermissao('CHEFE_SEPLAN');
      const verificarUnidadeApoiadora = this.verificarSePerfilTemPermissao('UNIDADE_APOIADORA');
      const verificarGerenteDHR = this.verificarSePerfilTemPermissao('GERENCIA');
      const verificarAdmin = this.verificarSePerfilTemPermissao('ADMINISTRADOR_SISTEMA');
    
      if(verificarAdmin){
        return verificarAdmin;
      }
    
      if(verificarGerenteDHR){
        return verificarGerenteDHR;
      }

      if(parametrizarExclusao == 0){
        return false
      }

      if(this.verificarSePerfilSetadoTemPermissao(this.funcionalidadesEnum.EXCLUIR_FERIAS)){
        return true;
      }

      return (verificarChefeSeplan || verificarUnidadeApoiadora ) && parametrizarExclusao == 1 ;
    },

    verificarSePerfilTemPermissao(perfil){
      return this.$store.state.perfil_id == tipoPerfil[perfil];
    },

    verificarSePerfilSetadoTemPermissao(funcionalidade_id){
      const permissao = this.$store.state.funcionalidades_perfil.find((value) => {
        return value.id == funcionalidade_id;
      });

      return !!permissao;
    },

    verificarPermisaoAnalisar(){
      const verificarChefeDireto = (this.$store.state.user.Perfis.indexOf(tipoPerfil['CHEFE_DIRETO']) != -1 && this.statusSelected == 'Em Análise do Chefe Direto')
      const verificarChefeSeplan = (this.$store.state.user.Perfis.indexOf(tipoPerfil['CHEFE_SEPLAN']) != -1 && this.statusSelected == 'Em Análise do Chefe SEPLAN (Ou Similares)');
      const verificarComandanteDaCompanhia = (this.$store.state.user.Perfis.indexOf(tipoPerfil['COMANDANTE_COMPANHIA']) != -1 && this.statusSelected == 'Em Análise do Comandante da Companhia Operacional');
      const verificarGerencia = (this.$store.state.user.Perfis.indexOf(tipoPerfil['GERENCIA']) != -1 && this.statusSelected == 'Em Análise do Gerente (Chefe DRH)');
      const verficarComandante = (this.$store.state.user.Perfis.indexOf(tipoPerfil['COMANDANTE']) != -1 && this.statusSelected == 'Em Análise do Comandante (Ou Similares)');

      if(verficarComandante){
        return false;
      }
      if(verificarChefeDireto){
        return false;
      }
      if(verificarComandanteDaCompanhia){
        return false;
      }
      if(verificarGerencia){
        return false;
      }
     
      if(verificarChefeSeplan){
        return false;
      }
      return true;
    },

    verificarPermisaoAnalisarConvocacao(){

      
      const verificarChefeDireto = this.$store.state.user.Perfis.indexOf(tipoPerfil['CHEFE_DIRETO']) != -1 && this.statusSelected == 'Convocação em Análise  do Chefe Direto';
      const verificarGerencia = (this.$store.state.user.Perfis.indexOf(tipoPerfil['GERENCIA']) != -1 && this.statusSelected == 'Convocação em Análise do Gerente (Chefe DRH)');
      const verificarChefeSeplan = (this.$store.state.user.Perfis.indexOf(tipoPerfil['CHEFE_SEPLAN']) != -1 && this.statusSelected == 'Convocação em Análise do Chefe SEPLAN (Ou Similares)');
      const verificarComandanteUnidade = (this.$store.state.user.Perfis.indexOf(tipoPerfil['COMANDANTE']) != -1 && this.statusSelected == 'Convocação em Análise do Comandante');


      if(verificarChefeDireto && this.selectedAction.idPerfil == tipoPerfil['SOLICITANTE']){
        return false;
      }
      if(verificarGerencia){
        return false;
      }
      if(verificarComandanteUnidade){
        return false;
      }
      if(verificarChefeSeplan){
        return false;
      }
      return true;
    },

    verificarAgendarFerias(){
      return this.$store.state.user.Perfis.indexOf(tipoPerfil['CHEFE_SEPLAN']) != -1;
    },

 

    verificarFeriasProrrogadas(){
      return this.$store.state.user.Perfis.indexOf(tipoPerfil['CHEFE_SEPLAN']) != -1 || this.$store.state.user.Perfis.indexOf(tipoPerfil['UNIDADE_APOIADORA']) != -1;
    },

    verificarConvocarFerias(){
 
      const verificarChefeDireto = this.$store.state.user.Perfis.indexOf(tipoPerfil['CHEFE_DIRETO']) != -1;
      const verificarChefeSeplan = this.$store.state.user.Perfis.indexOf(tipoPerfil['CHEFE_SEPLAN']) != -1;
      
      const usuarioSolicitandoPropriaConvocacao = this.$store.state.user.idSigrh == this.selectedAction.idSigrh;
      
      if(usuarioSolicitandoPropriaConvocacao){
        return false;
      }
      
      let verificarPerfilIgual = true;
      this.$store.state.user.Perfis.forEach( (element) => {
        if(this.selectedAction.idPerfil == element){
          verificarPerfilIgual = false;
        }
      });

      if(verificarChefeDireto){
        if(this.selectedAction.idPerfil == tipoPerfil['SOLICITANTE']){
          return false;
        } 
      }

      console.log('verificarChefeDireto: ' + verificarPerfilIgual);

      if(verificarChefeSeplan){
        
        if(this.selectedAction.idPerfil == tipoPerfil['GERENCIA']){
          return false;
        }
      }
      
      // Lógica final de permissão
      const temApenasSolicitante = this.$store.state.user.Perfis.indexOf(tipoPerfil['SOLICITANTE']) != -1 && this.$store.state.user.Perfis.length == 1;
      const dataAtual = date("Y-m-d");
      const dentroPeríodo = this.selectedAction.dataIni <= dataAtual && this.selectedAction.dataFin >= dataAtual;

      
      const resultado = temApenasSolicitante ? true : dentroPeríodo;
      

      return resultado;
    },



    verificarPermisaoReprogramar(){
    
      if(this.selectedAction.IdStatus != 28 && this.selectedAction.IdStatus != 3){
        return true;
      }
     
      const dataAtual = date("Y-m-d");
      const feriasNaoEmGozo = this.selectedAction.dataIni > dataAtual;
      
      if (this.$store.state.user.Perfis.length <= 1) {
        return false; 
      }
      
      return !feriasNaoEmGozo;
    },

    verificarHistoricoFerias(){
      return true;
    },

    closeActionsDialog() {
      this.actionsDialog = false;
      this.getFerias();
    },

    async excluirFerias() {
      this.confirmDialog = false;
      await ExcluirFeriasService.excluirFeriasCivil(this.idSelected);
      this.getFerias();
    },

    redirectCalendarioMilitar () {
      this.$router.push('/');
    }
  },
};
